module.exports = __webpack_public_path__ + "img/ep4-3.adc3b168.png";